import {
    Alert,
    Box,
    Button,
    Grid,
    MenuItem,
    Select,
    TextField,
    Tooltip,
    Typography,
  } from "@mui/material";
  import moment from "moment";
  import { FC, useEffect, useState } from "react";
  import { RouteComponentProps, withRouter } from "react-router-dom";
  import { API_SLUGS, HELPER_TEXTS, ROUTES, STRINGS } from "../../constants";
  import { axiosInstance } from "../../services/axios";
  import copy from "copy-to-clipboard";
  import { ContentCopy } from "@mui/icons-material";
  import { autoType } from "d3";
import { IAlertState, useAlertState } from "../../store/alertState";
import variables from ".";
  var format = require("string-template");
  
  
  interface IAddForm extends RouteComponentProps {
    updateOnly?: boolean;
    name: string;
    updateUUID?: string;
    callback?: (data: any) => void;
    preventRedirect?: boolean;
    isGlobalPattern?: boolean;
  }
  
  const DeleteVariableForm: FC<IAddForm> = ({
    history,
    match,
    updateUUID,
    name,
    preventRedirect = false,
    isGlobalPattern,
    callback = undefined,
  }) => {

    const { setMessage } = useAlertState() as IAlertState;
    const [allowDelete, setAllowDelete] = useState(false);
    const handleDelete = async () => {
        try {
            const path = isGlobalPattern ? format(API_SLUGS.GET_VARIABLES_DATA, { id: updateUUID }) : format(API_SLUGS.PATTERN, { id: updateUUID })
            let deleteVariableResponse = await axiosInstance.delete(path);
            setMessage({ title: "Pattern Deleted Successfully", type: "success" })
            if (!preventRedirect) {
                history.push(ROUTES.GENERATOR_SETS);
              }
              if (callback) {
                callback(deleteVariableResponse);
              }

        } catch (error: any) {
            setMessage({ title: `${error?.response?.data?.message}`, type: "error" })
        }

    };
  
    return (
        <Grid container spacing={3}>
        <Grid item xs={12}>
            
            <Typography
                color="textPrimary"
                sx={{ mb: 1, textAlign: "left" }}
                variant="h6"
            >
                Enter pattern name to
                delete the pattern
            </Typography>

            <TextField
                autoComplete="off"
                sx={{ maxWidth: "50%", textAlign: "left" }}
                size="medium"
                fullWidth
                name="Api"

                placeholder={name}
                onChange={(e: any) => {
                    setAllowDelete(e.target.value === name);
                }}
                required
                variant="outlined"
            />

        </Grid>
        <Grid item xs={12}>
            <Button
                color="error"
                size="medium"
                variant="contained"
                disabled={!allowDelete}
                onClick={() => handleDelete()}
                sx={{ mr: 1 }}
            >
                Delete
            </Button>
        </Grid>
    </Grid>
    );
  };
  
  export default withRouter(DeleteVariableForm);  